/**
 * Copiar al portapapeles, sin fallar en silencio.
 *
 * `navigator.clipboard` exige contexto seguro y un gesto del usuario, y en
 * Android puede fallar por razones que no controlamos. El respaldo con
 * `textarea` + `execCommand` es feo y está obsoleto, pero es lo que salva el
 * caso — y si los dos fallan, la función lo DICE en vez de fingir éxito.
 */

export type ResultadoCopia = 'copiado' | 'fallo';

export async function copiarTexto(texto: string): Promise<ResultadoCopia> {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(texto);
      return 'copiado';
    } catch {
      // Sigue al respaldo.
    }
  }

  try {
    const area = document.createElement('textarea');
    area.value = texto;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.top = '0';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.focus();
    area.select();
    area.setSelectionRange(0, texto.length);
    const ok = document.execCommand('copy');
    area.remove();
    return ok ? 'copiado' : 'fallo';
  } catch {
    return 'fallo';
  }
}

/** ¿Se puede compartir texto con el sistema? En Android suele ser lo más cómodo. */
export function puedeCompartir(): boolean {
  return typeof navigator !== 'undefined' && typeof navigator.share === 'function';
}

export async function compartirTexto(texto: string): Promise<boolean> {
  if (!puedeCompartir()) return false;
  try {
    await navigator.share({ text: texto });
    return true;
  } catch {
    // Cancelar el diálogo de compartir lanza: no es un error que reportar.
    return false;
  }
}
